import { useState } from 'react';

export const useInput = (initialValue) => {
  const [inputValue, setInputValue] = useState(initialValue);

  const handleInputChange = (event) => {
    setInputValue(event.currentTarget.value);
  };

  return [inputValue, handleInputChange];
};
